import CloseModal from 'actions/modal/close_modal';
import connect from 'components/lib/connect';
import CreateConversation from 'actions/conversation/create_conversation';
import ReopenConversationModal from './reopen_conversation_modal';
import ReopenConversation from 'actions/conversation/reopen_conversation';

let mapExecuteToProps = function(executeAction, { onCancel, routingGroupId }) {
  return {
    onCancel,
    onCreateNewConversationClick: createConversation,
    onReopenConversationClick: reopenConversation,
  };

  function closeModal() {
    executeAction(CloseModal);
  }

  function createConversation() {
    closeModal();
    executeAction(CreateConversation, { routingGroupId });
  }

  function reopenConversation() {
    closeModal();
    executeAction(ReopenConversation);
  }
};

export default connect(() => {}, mapExecuteToProps)(ReopenConversationModal);
